<cs-camera-view #cameraView [aspectRatio]="aspectRatio"
  (cameraReady)="cameraReady.emit()"
  (cameraError)="cameraError.emit($event)"
  (permissionChange)="permissionChange.emit()">
</cs-camera-view>

<!-- collage: shown when the camera is stopped and photos exist -->
@if (!cameraView?.isActive && photos.length) {
  <!-- a lone photo always renders bare (camera-sized, no card) so every scanner's
       single-photo view matches the meal scanner; multi-photo keeps the carded grid -->
  <div class="collage-container" [class.bare]="bareCollage || photos.length === 1">
    <div class="collage-grid">
      @for (photo of photos; track $index; let i = $index) {
        <img #collagePhoto class="collage-photo" [src]="photo.dataUrl"
          [class.clickable]="photosClickable" (click)="onPhotoClick(i)" />
      }
    </div>

    @if (analyzing && !suppressAnalyzingOverlay) {
      <cs-scanner-analyzing-overlay
        [statusText]="statusText"
        [progress]="progress"
        [retryMessage]="retryMessage">
      </cs-scanner-analyzing-overlay>
    }
  </div>
}
